export default function () {
  const ErrorStatus = {
    404: {
      statusCode: 404,
      statusMessage: 'Page not found'
    }
  } as const

  type ErrorStatus = keyof typeof ErrorStatus

  const throwError = (status: ErrorStatus) => {
    throw createError({
      statusCode: ErrorStatus[status].statusCode,
      statusMessage: ErrorStatus[status].statusMessage
    })
  }

  return {
    throwError
  }
}
